<template>
  <div class="page-content">
    <!-- <div class="kinput">
      <select name="" id="" class="kinput-select">
        <option value="" class="kinput-select__option">请选择咨询类型</option>
      </select>
    </div> -->
    <DafuItem v-for="item in list" :key="item.id" :item="item"></DafuItem>
    <div class="z-pagination" v-if="total">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="current_page"
        :page-size.sync="per_page"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <span class="z-pagination__total"> 共 {{ total }} 条 </span>
    </div>
  </div>
</template>

<script>
import { getZixundafuPage as getList } from "@/apis/hudong";
import DafuItem from "./components/DafuItem.vue";
export default {
  components: {
    DafuItem,
  },
  data() {
    return {
      per_page: 10,
      current_page: 1,
      total: 0,
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleCurrentChange(page) {
      this.$emit("currentChange", page);
      this.getList();
    },
    async getList() {
      const { data } = await getList({
        page: this.current_page,
        pagenum: this.per_page,
      });
      this.list = data.data;
      this.per_page = data.per_page;
      this.current_page = data.current_page;
      this.total = data.total;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
}
.kinput {
  width: 320px;
  background-color: #f5f5f5;
  border-radius: 5px;
  height: 42px;
  line-height: 42px;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
  .kinput-select {
    background-color: #f5f5f5;
    display: block;
    height: 100%;
    font-size: 14px;
    font-size: var(--font-size-14);
    font-weight: 500;
    line-height: 20px;
    color: #303133;
    border: none;
    width: 100%;
    outline: none;
    // appearance: none;
    .kinput-select-option {
      color: #303133;
      height: 42px;
      line-height: 42px;
    }
  }
}
</style>
